import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import TransferReceive from 'components/Inventory/WarehouseTransferReceive';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        {/*<h1>Warehouse</h1>*/}
        <TransferReceive />
      </SiteContent>
    </ContentLayout>
  );
};
